<template>
  <div class="loader">
    <div class="background" style="">
      <div class="progress">
        <div class="icon"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AttachmentLoader"
}
</script>

<style lang="scss" scoped>
.background {
  height: 41px;
  width: 40px;
  background-image: url(../../assets/images/Attachments-Background.svg);
}
.progress {
  -webkit-animation: attachmentLoading 2s linear infinite alternate;
  animation: attachmentLoading 2s linear infinite alternate;
  height: 41px;
  width: 41px;
  display: flex;
  justify-content: center; align-items: center;
  background-position: 0 -500%;
  background-repeat: repeat-x;
  background-image: url(../../assets/images/Attachments-Fill.svg);
  -webkit-mask-image: url(../../assets/images/Attachments-Mask.svg);
  -webkit-mask-size: 40px 41px;
  mask-image: url(../../assets/images/Attachments-Mask.svg);
  mask-size: 40px 41px;
}
.icon {
  height: 22px;
  width: 11px;
  background-image: url(../../assets/images/Attachments-Hourglass.svg);
}

@keyframes attachmentLoading {
  0% {
    background-position: 0 -550%;
  }
  100% {
    background-position: 0 100%;
  }
}

@-webkit-keyframes attachmentLoading {
  0% {
    background-position: 0 -550%;
  }
  100% {
    background-position: 0 100%;
  }
}


</style>
